import { Route, Router, Switch } from "wouter"
import ContentPage from "./content"
import ProjectsPage from "./projects"
import SchemeEditor from "./scheme-editor"

const App = () => {
  
  return (
    <Router base={process.env.PUBLIC_URL}>
      <Switch>
        <Route path="/schemes/:schemeId" component={SchemeEditor} />
        <Route path="/content/:id" component={ContentPage} />
        <Route path="/" component={ProjectsPage} />
      </Switch>
    </Router>
  )
}

export default App